.constitution__list {
  list-style: none;
}
